import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useUserStore } from '../store/useUserStore';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useMatchStore } from '../store/useMatchStore';
import location_dark from '../assets/images/location_dark.png';
import heart_dark from '../assets/images/heart_dark.png';
import ruler_dark from '../assets/images/ruler_dark.png';
import wine_icon from '../assets/images/wine_icon.png';
import pet_icon from '../assets/images/pet_icon.png';
import education_icon from '../assets/images/education_icon.png';
import kids_red from '../assets/images/kids_red.png';
import globe_icon from '../assets/images/globe_icon.png';
import tshirt_icon from '../assets/images/tshirt_icon.png';
import weet_icon from '../assets/images/weet_icon.png';
import workout_icon from '../assets/images/workout_icon.png';
import diamond_icon from '../assets/images/diamond_icon.png';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';


const MySwal = withReactContent(Swal);
import Chat from '../components/Chat';
import { useSendLikeStore } from '../store/useSendLikeStore';
import useAuthStore from '../store/useAuthStore';
import { useMessageStore } from '../store/useMessageStore';
import { updateCachedMatchesAfterAction } from '../utils/matchCacheUtils';
import { hasPremiumAccess } from '../utils/subscription';
import { useSubscriptionStore } from '../store/useSubscriptionStore';
import ProfileCarousel from '../components/ProfileCarousel';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

type Photo = {
  picture: string;
  orignal_picture: string;
}; 

const ProfileDetails = () => {
    const { userId } = useParams<{ userId: string }>();
  const { user, getUserDetails, genres, fetchGenres } = useUserStore();
  const { rows, currentPage, cachedMatches, moreLikeThem, getMatch, getMoreLikeThem, strikeout, blockUser,
    reportUser, } = useMatchStore();
    const [showMessaging, setShowMessaging] = useState(false);
    const [currentRecipient, setCurrentRecipient] = useState<{ id: number; name:string, city: string; state: string; distance: number, pic:string } | null>(null);
    
    const { loadinglike, sendLike, sendDiamond } = useSendLikeStore();
    
    const navigate = useNavigate();
    const authStore = useAuthStore.getState();
    const { request, getRequest } = useMessageStore();
    const { paymentDetails, getSubscription } = useSubscriptionStore();
    const [backgroundPhotos, setBackgroundPhotos] = useState<Photo[]>([]);
    const [likedUsers, setLikedUsers] = useState<Set<number>>(new Set());
    const [diamondUsers, setDiamondUsers] = useState<Set<number>>(new Set());
   

  useEffect(() => {
    console.log('userId:', userId);
     window.scrollTo(0, 0);
    if (userId) {
      fetchMoreLikeThem(parseInt(userId))
      fetchGenres();
      getSubscription(authStore.user?.id);
      getRequest(authStore.user.id, parseInt(userId));
      getUserDetails(parseInt(userId));
    }
  }, [userId]); 

  const fetchMoreLikeThem = (currentProfileId:any) => {
    getMoreLikeThem(currentProfileId);
  };

  const handleStrikeout = async (id:any) => {
    strikeout(id);
    const updatedCachedMatches = cachedMatches.filter(match => match.id !== id);
    if (rows.length < 2) {
      if (updatedCachedMatches.length > 0) {
        useMatchStore.setState({ cachedMatches: updatedCachedMatches });
      } else {
        await getMatch(currentPage + 1);
      }
    } else {
      useMatchStore.setState({ cachedMatches: updatedCachedMatches });
    }
  };

  const getAnswerBySubtitle = (subTitle: any) => {
    const answer = user.user_answers.find((ans:any) => {
        return ans.question != null && ans.question.sub_title === subTitle;
      });
     
        const skipFormatting = ['Politics', 'Kids_People'];
     
      if (!answer) return skipFormatting.includes(subTitle)
            ? `Not specified`
            : `${subTitle
                .replace(/_/g, ' ')
                .replace(/\b\w/g, (c: string) => c.toUpperCase())}: Not specified`;
  
      let answerIds = answer.answer_id;

      try {
        const parsed = JSON.parse(answerIds);
        if (Array.isArray(parsed)) {
          answerIds = parsed;
        }
      } catch (e:any) {
        console.log(e);
      }
    
      if (typeof answerIds === 'string') {
        answerIds = answerIds.includes(',')
          ? answerIds.split(',').map((item) => item.trim())
          : [answerIds.trim()];
      }
     
        answerIds = Array.isArray(answerIds) ? answerIds : [answerIds];

            const options = answer.question.questions_options
            ? answerIds
                .map((id: any) => {
                    const option = isNaN(id)
                    ? answer.question.questions_options.find((opt: any) => opt.option.trim() === id.trim())
                    : answer.question.questions_options.find((opt: any) => opt.id == id);
                    return option?.option;
                })
                .filter(Boolean)
            : answerIds;

            return options.length > 0 ? options.join(', ') : 'Not specified';
   };

    const confirmBlockUser = (userId:any, blockUser:any) => {
      MySwal.fire({
        html: (
          <div className="text-center">
            <h3>Block User?</h3>
            <p>Do you really want to block this user?</p>
            <div className="d-flex justify-content-center gap-2">
              <button className="btn btn-secondary" onClick={() => MySwal.close()}>
                Cancel
              </button>
              <button className="btn btn-danger" onClick={() => { 
                blockUser(userId); 
                updateCachedMatchesAfterAction(userId);
                navigate('/dashboard');
                MySwal.close();
              }}>
                Yes, Block
              </button>
            </div>
          </div>
        ),
        showConfirmButton: false,
        showCloseButton: true,
        customClass: {
          popup: 'bg-light p-4 rounded',
          closeButton: 'btn-close position-absolute top-0 end-0 m-3',
        },
      });
    };
    
    const confirmReportUser = (userId:any, reportUser:any) => {
      MySwal.fire({
        html: (
          <div className="text-center">
            <h3>Report User</h3>
            <p>Please enter the reason for reporting this user:</p>
            <textarea
              id="reportReason"
              className="form-control mb-3"
              placeholder="Enter your reason..."
              style={{ height: '100px', resize: 'none' }}
            ></textarea>
            <div className="d-flex justify-content-center gap-2">
              <button className="btn btn-secondary" onClick={() => MySwal.close()}>
                Cancel
              </button>
              <button
                className="btn btn-danger"
                onClick={() => {
                  const reasonInput = document.getElementById('reportReason') as HTMLTextAreaElement;
                  if (!reasonInput || !reasonInput.value.trim()) {
                    MySwal.showValidationMessage('Reason is required.');
                    return;
                  }
                  reportUser(userId, reasonInput.value.trim());
                  MySwal.close();
                  MySwal.fire('Reported!', 'The user has been reported successfully.', 'success');
                }}
              >
                Submit Report
              </button>
            </div>
          </div>
        ),
        showConfirmButton: false,
        showCloseButton: true,
        customClass: {
          popup: 'bg-light p-4 rounded',
          closeButton: 'btn-close position-absolute top-0 end-0 m-3',
        },
      });
    };    

  const convertHeightToCm = (height: any) => {
    if (height == null || typeof height !== 'string') {
      console.error('Invalid height input:', height);
      return "Not set";
    }
    const standardizedHeight = height.trim().replace(/'/g, "'").replace(/"/g, '"');
    const match = standardizedHeight.match(/^(\d+)'\s*(\d+)"?$/);
    if (!match) {
      console.error('Height format incorrect:', height);
      return "Invalid height format. Use: feet'inches\" (e.g., 5'10\")";
    }
    const feet = parseInt(match[1], 10);
    const inches = parseInt(match[2] || '0', 10);
    if (feet < 0 || inches < 0 || inches >= 12) {
      console.error('Height values out of range:', { feet, inches });
      return "Invalid height range";
    }
    const totalCm = feet * 30.48 + inches * 2.54;
    return `${totalCm.toFixed(0)} cm`;
  };

  const getSelectedGenres = () => {
    if (!user || !user.genres || !genres || !genres.length) return [];
    const genreIds = user.genres.split(',').map((id:any) => parseInt(id.trim()));
    return genres.filter((genre) => genreIds.includes(genre.id));
  };

  const selectedGenres = getSelectedGenres();

  const userGenres = authStore.user?.genres?.split(",").map(Number);
  let commonGenres:any = [];
  if(userGenres){
    commonGenres = selectedGenres.filter(genre => 
      userGenres.includes(genre.id)
    );
  }

  // ❤️ LIKE — with toast + state tracking
  const handleSendLike = async (id: any) => {
    const success = await sendLike(id, 50, '', '');
    if (success) {
      toast.success("Liked Successfully! ❤️");
      setLikedUsers(prev => new Set(prev).add(id));
    } else {
      showUpgradePlanAlert();
    }
    await updateCachedMatchesAfterAction(id);
  };

  // 💎 DIAMOND — with custom icon toast + state tracking
  const handleSendDiamond = async (id: any) => {
    const ok = await sendDiamond(id);

    if (ok) {
      setDiamondUsers(prev => new Set(prev).add(id));
      setLikedUsers(prev => new Set(prev).add(id));
      toast(
        () => (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <img src={diamond_icon} alt="" style={{ width: '20px', height: '20px' }} />
            <span>Diamond Sent Successfully!</span>
          </div>
        ),
        {
          position: 'top-right',
          autoClose: 3000,
          style: { background: '#e8f4fd', color: '#1a6fa5', fontWeight: 500 },
        }
      );
    } else {
      MySwal.fire({
        html: (
          <div className="text-center">
            <img src={diamond_icon} alt="Diamond" style={{ width: '40px', marginBottom: '10px' }} />
            <h3>Limit Reached</h3>
            <p>You've used all your diamonds for today.</p>
            <div className="d-flex justify-content-center gap-2">
              <button className="btn btn-secondary" onClick={() => MySwal.close()}>
                Close
              </button>
              <button
                className="btn btn-primary"
                onClick={() => {
                  MySwal.close();
                  navigate('/settings#subscription');
                }}
              >
                Upgrade Now
              </button>
            </div>
          </div>
        ),
        showConfirmButton: false,
        showCloseButton: true,
        customClass: {
          popup: 'bg-light p-4 rounded',
          closeButton: 'btn-close position-absolute top-0 end-0 m-3',
        },
      });
    }

    await updateCachedMatchesAfterAction(id);
  };

  const showUpgradePlanAlert = () => {
    MySwal.fire({
      html: (
        <div className="text-center">
          <h3>Upgrade Plan</h3>
          <p>Upgrade your plan to send more messages.</p>
          <div className="d-flex justify-content-center gap-2">
            <button className="btn btn-secondary" onClick={() => MySwal.close()}>
              Close
            </button>
            <button
              className="btn btn-primary"
              onClick={() => {
                MySwal.close();
                navigate('/settings#subscription');
              }}
            >
              Upgrade Now
            </button>
          </div>
        </div>
      ),
      showConfirmButton: false,
      showCloseButton: true,
      customClass: {
        popup: 'bg-light p-4 rounded',
        closeButton: 'btn-close position-absolute top-0 end-0 m-3',
      },
    });
  };

  const isPremium = hasPremiumAccess(paymentDetails);

  useEffect(() => {
    if (user && Array.isArray(user.user_photos)) {
      setBackgroundPhotos(user.user_photos);
    }
  }, [user]);

  return (
    <section className="pt-4 pb-60 bg-light dating_profile_page">
    <div className="container">
        <div className="dp_profile_top_bredcrumb mb-4">
            <Link to="/dashboard" className="bck_btn"><i className="fa-solid fa-arrow-left"></i> Back </Link>
            <div className="dp_profile_drpdwn_wrpr">
                <button className="btn btn-sm dropdown-toggle dp_profile_info_drpdwn" type="button"
                    data-bs-toggle="dropdown" aria-expanded="false">
                    Flag as inappropriate <i className="fa-solid fa-ellipsis-vertical"></i>
                </button>
                <ul className="dropdown-menu">
                <li><button className="dropdown-item" onClick={() => confirmBlockUser(user.id, blockUser)}>Block User</button></li>
                <li><button className="dropdown-item" onClick={() => confirmReportUser(user.id, reportUser)}>Report</button></li>
                </ul>
            </div>
        </div>
        {user && (
        
        <div className="row">
            <div className="col-lg-8 mb-3">
                <div className="card dating_profile_details_card p-4">

                    <ProfileCarousel
                      backgroundPhotos={backgroundPhotos}
                      user={user}
                    />
                    
                    <div className="dp_details_profile_info pt-4">
                        <div className="row align-items-center">
                            <div className="col-xl-8">
                                <h2>{user.first_name}, {user.age}</h2>
                                <ul>
                                    <li><img src={location_dark} />{user.city}, {user.state} - {user.distance.toFixed(0)} miles away</li>
                                    <li><img src={heart_dark} />{getAnswerBySubtitle('Relationship_status')}</li>
                                    <li><img src={ruler_dark} />{user.height} ({convertHeightToCm(user.height)})</li>
                                </ul>
                            </div>
                            <div className="col-xl-4">
                              {request == 0 ?
                            <div className="dp_actions_btngroup">

                                        {/* ❌ Pass */}
                                        <div className="dp_actions_btn_item">
                                            <button className="btn pass_btn" onClick={() => {
                                              handleStrikeout(user.id);
                                              navigate('/dashboard');
                                            }}>
                                                <i className="fa-solid fa-xmark"></i>
                                            </button>
                                            Pass
                                        </div>

                                        {/* 💬 Message */}
                                        <div className="dp_actions_btn_item" data-bs-toggle="offcanvas" 
                                            data-bs-target="#datingprofileChat" aria-controls="datingprofileChat">
                                            <button className="btn message_btn" onClick={() => {
                                                if(isPremium){
                                              setShowMessaging(true);
                                              setCurrentRecipient({
                                                id: user.id,
                                                name:`${user.first_name}, ${user.age}`,
                                                city: user.city,
                                                state: user.state,
                                                distance: user.distance,
                                                pic: user.picture || user.pic
                                              });
                                               }else{
                                                  showUpgradePlanAlert();
                                               }
                                            }}>
                                                <i className="fa-solid fa-paper-plane"></i>
                                            </button>
                                            Message
                                        </div>
                                       
                                        {/* ❤️ Like — with sent state */}
                                        <div className="dp_actions_btn_item">
                                            <button
                                              className="btn like_btn"
                                              onClick={() => handleSendLike(user.id)}
                                              disabled={loadinglike || likedUsers.has(user.id)}
                                              style={likedUsers.has(user.id) ? { opacity: 0.7, cursor: 'not-allowed' } : {}}
                                            >
                                              <i
                                                className={`fa-heart ${
                                                  likedUsers.has(user.id) ? "fa-solid text-danger" : "fa-regular"
                                                }`}
                                              ></i>
                                            </button>
                                            <span style={likedUsers.has(user.id) ? { color: '#e74c3c', fontWeight: 600 } : {}}>
                                              {likedUsers.has(user.id) ? "Liked" : "Like"}
                                            </span>
                                        </div>

                                        {/* 💎 Diamond — White background + sent state */}
                                        <div className="dp_actions_btn_item">
                                            <button
                                              className="btn diamond_btn"
                                              onClick={() => handleSendDiamond(user.id)}
                                              disabled={loadinglike || diamondUsers.has(user.id)}
                                              style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                backgroundColor: '#ffffff',   // ✅ White background
                                                border: '1px solid #d0d0d0',  // ✅ Subtle border
                                                borderRadius: '50%',
                                                ...(diamondUsers.has(user.id) ? { opacity: 0.7, cursor: 'not-allowed' } : {}),
                                              }}
                                            >
                                              <img
                                                src={diamond_icon}
                                                alt="Diamond"
                                                style={{
                                                  width: '22px',
                                                  height: '22px',
                                                  objectFit: 'contain',
                                                  transition: 'transform 0.2s ease',
                                                  ...(diamondUsers.has(user.id) ? { filter: 'brightness(0.8)' } : {}),
                                                }}
                                                onMouseOver={(e) => {
                                                  if (!diamondUsers.has(user.id)) {
                                                    e.currentTarget.style.transform = 'scale(1.15)';
                                                  }
                                                }}
                                                onMouseOut={(e) => {
                                                  e.currentTarget.style.transform = 'scale(1)';
                                                }}
                                              />
                                            </button>
                                            <span style={diamondUsers.has(user.id) ? { color: '#1a6fa5', fontWeight: 600 } : {}}>
                                              {diamondUsers.has(user.id) ? "Sent" : "Diamond"}
                                            </span>
                                        </div>

                                    </div>
                                    :''}

                            </div>
                          
                        </div>
                        <div className="border-top pt-3 mt-3">
                          <p>{user.know_about_you}</p>
                        </div>
                        <div className="border-top pt-3 mt-3">
                            <h5 className="font18 mb-3">Common Interests</h5>
                            <div className="danger_badge_group">
                              {commonGenres.length > 0 ? (
                                commonGenres.map((genre:any, index:any) => (
                                  <span key={index}>{genre.name}</span>
                                ))
                              ) : (
                                <span>No common interests</span>
                              )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card mt-4 p-4 ">
                    <h5 className="font22 mb-4 pb-3 border-bottom">About</h5>
                    <div className="row g-4">
                        <div className="col-md-5">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box"><i className="fa-solid fa-venus"></i></div>
                                <p className="mb-0 font18 ms-2">{getAnswerBySubtitle('Gender')}</p>
                            </div>
                        </div>
                        <div className="col-md-7">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box"><i className="fa-regular fa-heart"></i></div>
                                <p className="mb-0 font18 ms-2">{getAnswerBySubtitle('Relationship_status')}, intent: {getAnswerBySubtitle('Looking_Relationship')}, interested in {getAnswerBySubtitle('Seeking')}</p>
                            </div>
                        </div>
                        <div className="col-md-5">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box">
                                    <img src={education_icon} alt="" />
                                </div>
                                <p className="mb-0 font18 ms-2">{getAnswerBySubtitle('Education')}</p>
                            </div>
                        </div>
                        <div className="col-md-7">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box"><i className="fa-solid fa-briefcase"></i></div>
                                <p className="mb-0 font18 ms-2 capitalize-first">{user.occupation ?? 'Occupation : Not specified'}</p>
                            </div>
                        </div>
                        <div className="col-md-5">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box"><i className="fa-solid fa-book-open"></i></div>
                                <p className="mb-0 font18 ms-2">{getAnswerBySubtitle('Religion')}</p>
                            </div>
                        </div>
                        <div className="col-md-7">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box">
                                    <img src={kids_red} alt="" />
                                </div>
                                <p className="mb-0 font18 ms-2">{getAnswerBySubtitle('Have_kids')}</p>
                            </div>
                        </div>
                        <div className="col-md-5">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box">
                                    <img src={globe_icon} alt="" />
                                </div>
                                <p className="mb-0 font18 ms-2">{getAnswerBySubtitle('Ethnicity')}</p>
                            </div>
                        </div>
                        <div className="col-md-7">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box">
                                    <img src={tshirt_icon} alt="" />
                                </div>
                                <p className="mb-0 font18 ms-2">{getAnswerBySubtitle('Body_type')}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card mt-4 p-4 ">
                    <h5 className="font22 mb-4 pb-3 border-bottom">Lifestyle</h5>
                    <div className="row g-4">
                        <div className="col-md-5">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box"><i className="fa-solid fa-smoking"></i></div>
                                <p className="mb-0 font18 ms-2">{getAnswerBySubtitle('Smokes')}</p>
                            </div>
                        </div>
                        <div className="col-md-7">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box">
                                    <img src={weet_icon} alt="" />
                                </div>
                                <p className="mb-0 font18 ms-2">{getAnswerBySubtitle('420_firendly')}</p>
                            </div>
                        </div>
                        <div className="col-md-5">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box">
                                    <img src={wine_icon} alt="" />
                                </div>
                                <p className="mb-0 font18 ms-2">{getAnswerBySubtitle('Drinks')}</p>
                            </div>
                        </div>
                        <div className="col-md-7">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box">
                                    <img src={workout_icon} alt="" />
                                </div>
                                <p className="mb-0 font18 ms-2">{getAnswerBySubtitle('Exercise')}</p>
                            </div>
                        </div>
                        <div className="col-md-5">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box">
                                    <img src={pet_icon} alt="" />
                                </div>
                                <p className="mb-0 font18 ms-2">{getAnswerBySubtitle('Have_pets')}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card mt-4 p-4">
                    <h5 className="font22 mb-4 pb-3 border-bottom">Personality Type</h5>
                    <div className="danger_outline_badge_group">
                        {Array.isArray(getAnswerBySubtitle('Personality'))
                        ? getAnswerBySubtitle('Personality').map((trait: string, index: number) => (
                            <span key={index}>{trait}</span>
                        ))
                        : getAnswerBySubtitle('Personality').split(',').map((trait: string, index: number) => (
                          <span key={index}>{trait}</span>
                      ))
                     }
                    </div>
                </div>
                <div className="card mt-4 p-4">
                    <h5 className="font22 mb-4 pb-3 border-bottom">Extended Profile</h5>
                    <div className="danger_outline_badge_group">
                        <span>{getAnswerBySubtitle('Horoscope')}</span>
                        <span>Looking for match between {user.looking_min_age}-{user.looking_max_age}</span>
                        <span>Political affiliation is {getAnswerBySubtitle('Politics')}</span>
                        <span>Will date people that have Kid? - {getAnswerBySubtitle('Kids_People')}</span>
                    </div>
                </div>
                <div className="card mt-4 p-4">
                    <h5 className="font22 mb-4 pb-3 border-bottom">Interests Feature</h5>
                    <div className="danger_outline_badge_group">
                    {selectedGenres.length > 0 ? (
                      selectedGenres.map((genre, index) => (
                        <span key={index}>{genre.name}</span>
                      ))
                    ) : (
                      <span>No interests selected</span>
                    )}
                    </div>
                </div>
            </div>
            <div className="col-lg-4">
                <div className="card pb-0">
                    <h5 className="font22 mb-4 pb-3 border-bottom">More like them</h5>
                    <div className="dp_morelikethis_profiles">
                    {moreLikeThem.length > 0 ? (
                        <>
                          {moreLikeThem?.map((profile: any) => (
                            <div key={profile.id} className="d-flex mb-3 cursor-pointer" onClick={() => {navigate(`/profile/${profile.id}`);}}>
                            <div className="dp_morelikethis_prf_img">
                                <img className="w-100" src={profile.picture || profile.pic} alt="" />
                            </div>
                            <div className="dp_morelikethis_prf_cnt">
                                <h5 className="mb-0 font18">{profile.first_name}, {profile.age}</h5>
                                <p><img src={location_dark} className="me-2" />{profile.city} {profile.state}, {profile.distance.toFixed(0)} miles away</p>
                            </div>
                        </div>
                          ))}
                        </>
                    ) : (
                      <p>No similar profiles available.</p>
                    )}
                    </div>
                </div>
            </div>
        </div>
      )}
    </div>
    {showMessaging && currentRecipient && (
            <Chat 
              toUser={currentRecipient.id}
              name={currentRecipient.name}
              city={currentRecipient.city}
              state={currentRecipient.state}
              distance={currentRecipient.distance}
              pic={currentRecipient.pic}
              show={showMessaging} 
              handleClose={() => setShowMessaging(false)} 
            />
          )}
</section>
  );
};

export default ProfileDetails;